
import { Suspense, lazy } from 'react';
import { NavBar } from "@/components/NavBar";
import { QuickAccess } from "@/components/dashboard/QuickAccess";
import { ProgressChart } from "@/components/dashboard/ProgressChart";
import { ActivityChart } from "@/components/dashboard/ActivityChart";
import { SubscribeBanner } from "@/components/dashboard/SubscribeBanner";
import { useProfile } from "@/hooks/use-profile";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";

const Footer = lazy(() => import("@/components/Footer"));

const ProgressCharts = () => (
  <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 progress-charts">
    <ProgressChart taskType={1} />
    <ProgressChart taskType={2} />
  </div>
);

const DashboardContent = ({ showSubscribeBanner }: { showSubscribeBanner: boolean }) => (
  <div className="space-y-8 dashboard-container">
    {showSubscribeBanner && <SubscribeBanner />}
    <QuickAccess />
    <ActivityChart />
    <ProgressCharts />
  </div>
);

const Dashboard = () => {
  const { user, loading } = useAuth();
  const { profile } = useProfile();

  if (loading) {
    return (
      <div className="flex min-h-screen flex-col bg-stone-50 dark:bg-stone-950">
        <NavBar />
        <main className="flex-grow flex items-center justify-center">
          <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
        </main>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  const showSubscribeBanner = profile && !profile?.has_paid;

  return (
    <div className="flex min-h-screen flex-col bg-stone-50 dark:bg-stone-950">
      <NavBar />

      <main
        className="flex-grow px-4 py-8 container mx-auto max-w-6xl"
        aria-label="Dashboard"
      >
        <h1 className="sr-only">Dashboard</h1>
        <DashboardContent showSubscribeBanner={showSubscribeBanner} />
      </main>

      <Suspense fallback={<div className="h-16" />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Dashboard;
